import React from "react";

interface Device {
  id: string;
  name: string;
  specs: string;
  price: number;
}

interface TabletPlaceholderProps {
  searchQuery?: string;
  onSelect?: (device: Device) => void;
}

export const mockTablets = [
  {
    brand: "APPLE",
    devices: [
      {
        id: "t1",
        name: "iPad Air (M2)",
        specs: "128GB, WiFi",
        price: 699.0,
      },
      {
        id: "t2",
        name: 'iPad Pro 11" (M4)',
        specs: "256GB, WiFi",
        price: 1199.0,
      },
      { id: "t3", name: "iPad Mini", specs: "64GB, WiFi", price: 599.0 },
    ],
  },
  {
    brand: "SAMSUNG",
    devices: [
      { id: "t4", name: "Galaxy Tab S9", specs: "128GB", price: 799.0 },
      { id: "t5", name: "Galaxy Tab A9+", specs: "64GB", price: 249.0 },
    ],
  },
  {
    brand: "GOOGLE",
    devices: [{ id: "t6", name: "Pixel Tablet", specs: "128GB", price: 499.0 }],
  },
  {
    brand: "LENOVO",
    devices: [{ id: "t7", name: "Tab P12", specs: "128GB", price: 399.0 }],
  },
];

function TabletPlaceholder({
  searchQuery = "",
  onSelect,
}: TabletPlaceholderProps) {
  const filteredTablets = mockTablets
    .map((group) => ({
      ...group,
      devices: group.devices.filter((device) =>
        device.name.toLowerCase().includes(searchQuery.toLowerCase()),
      ),
    }))
    .filter((group) => group.devices.length > 0);

  return (
    <div className="device-table">
      <table className="device-table__table">
        <thead>
          <tr className="device-table__header-row">
            <th className="device-table__header-cell device-table__header-cell--name">
              Gerät
            </th>
            <th className="device-table__header-cell device-table__header-cell--specs">
              Specs
            </th>
            <th className="device-table__header-cell device-table__header-cell--price">
              EK(Netto)
            </th>
            <th className="device-table__header-cell device-table__header-cell--action">
              Aktion
            </th>
          </tr>
        </thead>
        <tbody>
          {filteredTablets.map((group) => (
            <React.Fragment key={group.brand}>
              <tr className="device-table__brand-row">
                <td colSpan={4}>
                  <div
                    className={`device-table__brand-label device-table__brand-label--${group.brand.toLowerCase()}`}
                  >
                    {group.brand}
                  </div>
                </td>
              </tr>
              {group.devices.map((device) => (
                <tr key={device.id} className="device-table__row">
                  <td className="device-table__cell device-table__cell--name">
                    {device.name}
                  </td>
                  <td className="device-table__cell device-table__cell--specs">
                    {device.specs}
                  </td>
                  <td className="device-table__cell device-table__cell--price">
                    {new Intl.NumberFormat("de-DE", {
                      style: "currency",
                      currency: "EUR",
                    }).format(device.price)}
                  </td>
                  <td className="device-table__cell device-table__cell--action">
                    <button
                      className="device-table__btn-select"
                      onClick={() => onSelect?.(device)}
                    >
                      Wählen
                    </button>
                  </td>
                </tr>
              ))}
            </React.Fragment>
          ))}
          {filteredTablets.length === 0 && (
            <tr>
              <td
                colSpan={4}
                style={{ textAlign: "center", padding: "2rem", color: "#999" }}
              >
                Keine Geräte gefunden
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}

export default TabletPlaceholder;
